<script>
export default {
    name: "ProductListSort",
    data() {
        return {
            sortData: {
                sortType: 'views',
                order: 'desc',
            }
        }
    },
    methods: {
        applySort(sort, order = 'desc') {
            this.sortData = {
                order,
                sortType: sort,
            };

            this.updateList();
        },
    },
}
</script>

<style scoped>

</style>
